import styled from 'styled-components';
import { DEVICES, pickThemeColor, pickThemeFontStyles } from '@/theme';
import { Button, Input, Link } from '@/ui';

export const StyledWrapper = styled.div`
  display: flex;
  flex-direction: column;
  flex-grow: 1;

  @media screen and ${DEVICES.LAPTOP_S} {
    background-color: transparent;
    padding: 0;
    gap: 1rem;
  }
`;

export const StyledText = styled.div`
  color: ${pickThemeColor('BLACK_PRIMARY')};
  ${pickThemeFontStyles('14', '22')};
  white-space: pre-wrap;

  a {
    color: ${pickThemeColor('ORANGE_PRIMARY')};
    font-style: italic;
    margin-left: 0.25rem;
  }

  @media screen and ${DEVICES.LAPTOP_S} {
    ${pickThemeFontStyles('16', '26')};
  }
`;

export const StyledTooltipContent = styled.div`
  &&& {
    padding: 1rem;
    color: ${pickThemeColor('WHITE')};
  }
`;

export const StyledRow = styled.div`
  display: flex;
  width: 100%;
  justify-content: space-between;
  flex-direction: column;
  gap: 0.5rem;

  @media screen and ${DEVICES.LAPTOP_S} {
    flex-direction: row;
    align-items: center;
    gap: 1rem;
  }
`;

export const StyledDivider = styled.div`
  width: 100%;
  height: 1px;
  background-color: ${pickThemeColor('LIGHT_PURPLE')};
`;

export const StyledInput = styled(Input)`
  width: 100%;
  max-width: 30rem;
`;

export const StyledCheckboxesGroup = styled.div`
  display: flex;
  width: 100%;
  flex-direction: row;
  flex-wrap: wrap;
  gap: 0.25rem;
`;

export const StyledCheckboxesBlock = styled.div`
  display: flex;
  width: 100%;
  flex-direction: column;
  gap: 1.5rem;
`;

export const StyledCheckboxGroup = styled.div`
  display: flex;
  width: 100%;
  gap: 0.25rem;
  align-items: center;
`;

export const StyledCheckboxText = styled.div`
  color: ${pickThemeColor('BLACK_PRIMARY')};
  ${pickThemeFontStyles('16', '26', 'SEMI_BOLD')};
  display: inline;

  &&& span {
    ${pickThemeFontStyles('14', '20', 'NORMAL')};
    display: inline !important;
    color: ${pickThemeColor('GREY_DARK')};
    text-transform: uppercase;
    margin-left: 0.25rem;
  }
`;

export const StyledTitle = styled.h1`
  ${pickThemeFontStyles('20', '26', 'SEMI_BOLD')};
  text-align: center;
  margin: 0;
  color: ${pickThemeColor('DARK_PURPLE')};

  @media screen and ${DEVICES.LAPTOP_S} {
    ${pickThemeFontStyles('20', '26', 'SEMI_BOLD')};
    text-align: left;
  }
`;

export const StyledButton = styled(Button)`
  &&& {
    z-index: 40;
    width: 100%;

    @media screen and ${DEVICES.LAPTOP_S} {
      width: 19.5rem;
    }
  }
`;

export const StyledContent = styled.div`
  display: flex;
  flex-direction: column;
  gap: 1rem;

  @media screen and ${DEVICES.LAPTOP_S} {
    margin-bottom: 2rem;
    justify-content: center;
  }
`;

export const StyledLink = styled(Link)`
  margin-top: auto;

  span {
    ${pickThemeFontStyles('14', '20')};
  }
`;

export const StyledMessage = styled.div`
  color: ${pickThemeColor('BLACK_PRIMARY')};
  ${pickThemeFontStyles('16', '26', 'NORMAL')};
`;
